<title>{{ newsPage.htmlTitle }}</title>
<app-banner [banner]="newsPage.banner"></app-banner>
<div class="container mt-5 mb-5">
  <div class="col-lg-12">
    <div class="row">
      <div
        class="col-sm-12 col-md-2 yearTabMenu"
        *ngFor="let newsYear of newsYears; let i = index"
        [ngClass]="selectedYearIndex === i ? 'active' : 'tabCss'"
        (click)="onYearTabClick(i)"
        [attr.aria-selected]="selectedYearIndex === i"
        role="tab"
        [attr.tabindex]="selectedYearIndex === i ? 0 : -1"
        style="cursor: pointer;"
      >
        <p class="yearTabTitle">{{ newsYear }}</p>
      </div>
    </div>
  </div>
</div>
<app-news-update-card [newsUpdateCards]="newsPage.newsUpdateCards" [newsYears]="newsYears" [selectedYearIndex]="selectedYearIndex"></app-news-update-card>
